function RedundantPages(nav: HTMLDivElement, triggerer: HTMLDivElement) {
  if (!nav || !triggerer) {
    return;
  }

  const settings = {
    triggered: 'triggered',
    isTriggered: false,
    iconOpenClass: 'fa-bars',
    iconCloseClass: 'fa-times'
  };

  triggerer.onclick = event => {
    event.preventDefault();
    const icon = triggerer.getElementsByTagName('i');

    if (!settings.isTriggered) {
      nav.classList.add(settings.triggered);
      triggerer.classList.add(settings.triggered);

      if (icon.length && icon.length > 0) {
        if (icon.length > 1) {
          icon[0].style.display = 'none';
          icon[1].style.display = 'inline-block';
        } else {
          icon[0].style.display = 'inline-block';
        }
      }

      settings.isTriggered = true;
      return;
    }

    nav.classList.remove(settings.triggered);
    triggerer.classList.remove(settings.triggered);

    if (icon.length && icon.length > 0) {
      if (icon.length > 1) {
        icon[0].style.display = 'inline-block';
        icon[1].style.display = 'none';
      } else {
        icon[0].style.display = 'none';
      }
    }

    settings.isTriggered = false;
  };
}

function SearchBar(nav: HTMLDivElement, searchTriggerer: HTMLDivElement, mobileTrigger: HTMLDivElement) {

  if (!nav || !searchTriggerer) {
    return;
  }

  const settings = {
    triggered: 'triggered',
    isTriggered: false
  };
  const searchBox = nav.querySelector('.empori-header-search');

  if (searchBox) {
    searchTriggerer.classList.add('pull-right');
  }
  searchTriggerer.onclick = event => {
    event.preventDefault();
    const icon = searchTriggerer.getElementsByTagName('i');
    if (!settings.isTriggered) {

      if (searchBox) {
        searchBox.classList.add(settings.triggered);
      }

      if (icon.length && icon.length > 0) {
        if (icon.length > 1) {
          icon[0].style.display = 'none';
          icon[1].style.display = 'inline-block';
        } else {
          icon[0].style.display = 'inline-block';
        }
      }

      settings.isTriggered = true;
      return;
    }
    nav.classList.remove(settings.triggered);
    searchTriggerer.classList.remove(settings.triggered);
    if (searchBox) {
      searchBox.classList.remove(settings.triggered);
    }

    if (icon.length && icon.length > 0) {
      if (icon.length > 1) {
        icon[0].style.display = 'inline-block';
        icon[1].style.display = 'none';
      } else {
        icon[0].style.display = 'none';
      }
    }

    settings.isTriggered = false;
  };
}

export default function MainNavigation(
  nav: HTMLDivElement,
  mobileTrigger: HTMLDivElement,
  redundantPagesNav: HTMLDivElement,
  redundantTrigger: HTMLDivElement,
  searchbar: HTMLDivElement) {

  const settings = {
    scrolled: 'scrolled',
    triggered: 'triggered',
    isTriggered: false,
    iconOpenClass: 'fa-bars',
    iconCloseClass: 'fa-times',
    threshold: 50
  };

  const rawMobileMenu = nav.querySelector('.raw-mobile-menu');

  if (window.scrollY > settings.threshold) {
    nav.classList.add(settings.scrolled);

    if (rawMobileMenu) {
      rawMobileMenu.classList.add(settings.scrolled);
    }
  }

  RedundantPages(redundantPagesNav, redundantTrigger);
  SearchBar(nav, searchbar, mobileTrigger);

  window.onscroll = () => {
    if (window.pageYOffset > settings.threshold) {
      nav.classList.add(settings.scrolled);

      if (rawMobileMenu) {
        rawMobileMenu.classList.add(settings.scrolled);
      }

    } else {
      nav.classList.remove(settings.scrolled);

      if (rawMobileMenu) {
        rawMobileMenu.classList.remove(settings.scrolled);
      }
    }
  };

  mobileTrigger.onclick = event => {
    event.preventDefault();
    const icon = mobileTrigger.getElementsByTagName('i');

    if (!settings.isTriggered) {
      nav.classList.add(settings.triggered);
      settings.isTriggered = true;

      if (icon.length && icon.length > 0) {
        if (icon.length > 1) {
          icon[0].style.display = 'none';
          icon[1].style.display = 'inline-block';
        } else {
          icon[0].style.display = 'inline-block';
        }
      }

      return;
    }

    nav.classList.remove(settings.triggered);
    settings.isTriggered = false;

    if (icon.length && icon.length > 0) {
      if (icon.length > 1) {
        icon[0].style.display = 'inline-block';
        icon[1].style.display = 'none';
      } else {
        icon[0].style.display = 'none';
      }
    }
  };
}